<template>
    <div class="expert-seminar-wrap">
        <bread-crumb :bread-list="breadList" />

        <div class="expert-seminar-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">医空间</span>
            </div>
            <div class="search-wrap">
                <div class="search-show-wrap">
                    <el-input class="search-input"
                              size="small"
                              placeholder="请输入课程名称"
                              v-model="selectForm.title"
                              @keyup.enter.native="handleSearch">
                        <i slot="suffix"
                           class="iconfont icon-search"
                           @click="handleSearch"></i>
                    </el-input>
                    <!-- 为了应付检查 之前写的 -->
                    <!-- <div class="option-item">
                        <span class="label">上线时间</span>
                        <el-select v-model="onlineTime"
                                   placeholder="请选择"
                                   size="small"
                                   :style="{width: '210px'}"
                                   @change="dataChange">
                            <el-option label="2020"
                                       value="2020">
                            </el-option>
                            <el-option label="2019"
                                       value="2019">
                            </el-option>
                            <el-option label="2018"
                                       value="2018">
                            </el-option>
                            <el-option label="2017"
                                       value="2017">
                            </el-option>
                        </el-select>
                    </div> -->
                    <div class="more-search"
                         @click="isMoreShow=!isMoreShow">
                        <span class="more-search-text">高级搜索</span>
                        <i class="iconfont icon-drop_down"
                           :class="[{'is-reverse': isMoreShow}]"></i>
                    </div>
                </div>
                <div>
                    <!-- <el-button size="small"
                           @click="queryGoodsList">精品课程排序</el-button> -->
                    <el-button size="small"
                            @click="handleAdd">创建课程</el-button>
                </div>
            </div>
            <!-- 为了应付检查 之前写的 -->
            <!-- <div class="pian-none">
                {{showWord}}
            </div> -->
            <div class="hide-wrap"
                 v-if="isMoreShow">
                <div class="option-wrap">
                    <div class="option-item">
                        <span class="label">课程名称</span>
                        <el-input placeholder="请输入课程名称"
                                  v-model="selectForm.title"
                                  :style="{width: '240px'}">
                        </el-input>
                    </div>
                    <div class="option-item">
                        <span class="label">状态</span>
                        <el-select v-model="selectForm.isUsed"
                                   placeholder="请选择"
                                   size="small"
                                   clearable
                                   :style="{width: '240px'}"
                                   @change="handleSearch">
                            <el-option label="全部"
                                       value="">
                            </el-option>
                            <el-option label="已上线"
                                       :value="1">
                            </el-option>
                            <el-option label="未上线"
                                       :value="0">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="option-item">
                        <span class="label">来源医生</span>
                        <el-input placeholder="请输入来源医生"
                                  v-model="selectForm.doctorName"
                                  :style="{width: '240px'}">
                        </el-input>
                    </div>
                    <!-- <div class="option-item">
                        <span class="label">精品课程</span>
                        <el-select v-model="selectForm.isGoods"
                                   placeholder="请选择"
                                   size="small"
                                   clearable
                                   :style="{width: '240px'}"
                                   @change="handleSearch">
                            <el-option label="全部"
                                       value="">
                            </el-option>
                            <el-option label="否"
                                       :value="0">
                            </el-option>
                            <el-option label="是"
                                       :value="1">
                            </el-option>
                        </el-select>
                    </div> -->
                    <div class="option-item">
                        <span class="label">课程类型</span>
                        <el-select v-model="selectForm.seminarType"
                                   placeholder="请选择"
                                   size="small"
                                   clearable
                                   :style="{width: '240px'}"
                                   @change="handleSearch">
                            <el-option label="全部"
                                       value="">
                            </el-option>
                            <el-option label="原创"
                                       :value="1">
                            </el-option>
                            <el-option label="外链"
                                       :value="2">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="option-item">
                        <span class="label">上线时间</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.addedTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>

                    <div class="option-item">
                        <span class="label">创建日期</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.createTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>
                    <div class="select-btn-wrap">
                        <el-button type="primary"
                                   size="small"
                                   @click="handleSearch">查询</el-button>
                        <el-button type="info"
                                   size="small"
                                   plain
                                   @click="resetCondition">重置</el-button>
                    </div>
                </div>
            </div>

            <div class="table-wrap">
                <el-table :data="dataList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column min-width="60px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="250px"
                                     label="课程">
                        <template slot-scope="scope">
                            <div class="image_title">
                                <el-image v-if="scope.row.pictureId"
                                          class="cover-picture"
                                          :src="'/ms-hoc-video/v1/image/download?fileName='+ scope.row.pictureId">
                                </el-image>
                                <div class="text_title" v-if="scope.row.title">
                                    <el-tooltip :disabled="scope.row.title.length<23 ? true : false"
                                                popper-class="short-popper"
                                                effect="dark"
                                                placement="top">
                                        <span class="image_text">{{ scope.row.title }}</span>
                                        <span slot="content">{{ scope.row.title }}</span>
                                    </el-tooltip>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="110px"
                                     label="来源">
                        <template slot-scope="scope">
                            <span v-if="scope.row.seminarType==='2'">{{scope.row.expertFrom}}</span>
                            <span v-else>{{scope.row.doctorName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price"
                                     min-width="90px"
                                     label="价格（元）">
                        <template slot-scope="scope">
                            <span>{{scope.row.price || '-'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="80px"
                                     label="状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isUsed"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已上线</span>
                            </div>
                            <div v-else
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">未上线</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="80px"
                                     label="课程类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.seminarType==='2'">外链</span>
                            <span v-else>原创</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="100px"
                                     label="关联模块">
                        <template slot-scope="scope">
                            <div v-if="scope.row.modules&&scope.row.modules.length>0">
                                <span v-for="(item, index) in scope.row.modules"
                                    :key="index">
                                    {{ item.moduleName+'；'}}
                                </span>
                            </div>
                            <div v-else>
                                -
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="100px"
                                     label="关联标签">
                        <template slot-scope="scope">
                            <div v-if="scope.row.labels&&scope.row.labels.length>0">
                                <span v-for="(item, index) in scope.row.labels"
                                    :key="index">
                                    {{ item.name+'；'}}
                                </span>
                            </div>
                            <div v-else>
                                -
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px"
                                     label="上线时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.addedTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px"
                                     label="创建时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.createTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="creatorUserName"
                                     min-width="100px"
                                     label="创建者">
                    </el-table-column>
                    <el-table-column fixed="right"
                                     label="排序"
                                     width="90">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isUsed && isStatsShow"
                                 class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="scope.row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="handleMoveUp(scope.row.expertSeminarId)"></i>

                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="scope.row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="handleMoveDown(scope.row.expertSeminarId)"></i>
                            </div>
                            <div v-else
                                 class="status-off">
                                <i class="iconfont icon-paixushang"></i>
                                <i class="iconfont icon-paixuxia"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right"
                                     label="操作"
                                     width="260">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isUsed"
                                 class="star-status">
                                <span @click="handleClick(scope.row.expertSeminarId, 'off', scope.row.isGoods)"
                                      class="link-btn">下线</span>
                                <span @click="showModule(scope.row)"
                                      class="link-btn">选择模块</span>
                                <span @click="showLabel(scope.row)"
                                      class="link-btn">选择标签</span>
                                <span @click="showEdu(scope.row)"
                                      class="link-btn">试卷管理</span>
                                      <!-- <i class="iconfont icon-collection icon-on"
                                         v-if="scope.row.isGoods"
                                         @click="cancleGoods(scope.row.expertSeminarId, 'off')"></i>
                                      <i class="iconfont icon-collection icon-off"
                                         @click="setGoods(scope.row.expertSeminarId, 'on')"
                                         v-else></i> -->
                            </div>
                            <div v-else>
                                <span @click="handleClick(scope.row.expertSeminarId, 'on')"
                                      class="link-btn">上线</span>

                                <span @click="handleClick(scope.row.expertSeminarId, 'edit')"
                                      class="link-btn">编辑</span>
                                <span @click="showLabel(scope.row)"
                                      class="link-btn">选择标签</span>
                                <span @click="showEdu(scope.row)"
                                      class="link-btn">试卷管理</span>
                                <span @click="handleClick(scope.row.expertSeminarId, 'delete')"
                                      class="link-btn">删除</span>
                            </div>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handlePageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="prev, pager, next, jumper, total"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog  title="选择模块"
                    :visible.sync="isModuleShow"
                    :close-on-click-modal="false"
                    class="choose-module-dialog"
                    width="560px">
            <div class="table">
                <el-table :data="moduleList"
                          stripe
                          height="100%"
                          max-height="560px"
                          ref="chooseModuleTable"
                          v-loading="moduleLoading"
                          @selection-change="handleSelectionChange"
                          style="width: 100%">
                    <el-table-column type="selection"
                                    align="center"
                                    width="100">
                    </el-table-column>
                    <el-table-column prop="name"
                                    label="模块">
                        <template slot-scope="scope">
                            {{scope.row.moduleName}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer"
                  class="dialog-footer">
                <el-button type="warning"
                            size="small"
                            :disabled="moduleList.length<=0"
                            @click="sureChooseModule()">确 定</el-button>
                <el-button size="small"
                            type="info"
                            plain
                            @click="cancelChooseModule('module')">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog  title="选择标签"
                    :visible.sync="isLabelShow"
                    :close-on-click-modal="false"
                    class="choose-module-dialog"
                    width="560px">
            <div class="table">
                <el-table :data="labelList"
                          stripe
                          height="100%"
                          max-height="560px"
                          ref="chooseLabelTable"
                          v-loading="labelLoading"
                          @selection-change="handleLabelChange"
                          style="width: 100%">
                    <el-table-column type="selection"
                                    align="center"
                                    width="100">
                    </el-table-column>
                    <el-table-column prop="name"
                                    label="标签">
                        <template slot-scope="scope">
                            {{scope.row.name}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer"
                  class="dialog-footer">
                <el-button type="warning"
                            size="small"
                            :disabled="labelList.length<=0"
                            @click="sureChooseLabel()">确 定</el-button>
                <el-button size="small"
                            type="info"
                            plain
                            @click="cancelChooseModule('label')">取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog  title="试卷管理"
                    :visible.sync="isEduShow"
                    :close-on-click-modal="false"
                    class="choose-exma-dialog"
                    @close="cancelChooseExam"
                    width="720px">
            <div class="search-exam">
                <el-input class="search-doctor"
                            placeholder="请输入考试名称"
                            v-model="examinationName"
                            @keyup.enter.native="searchExam">
                    <i slot="suffix"
                        class="iconfont icon-search"
                        @click="searchExam"></i>
                </el-input>
            </div>
            <div class="table">
                <el-table :data="eduList"
                          stripe
                          ref="chooseEduTable"
                          v-loading="eduLoading"
                          style="width: 100%">
                    <el-table-column type="selection"
                                     width="40">
                        <template slot-scope="scope">
                            <el-radio class="radio" v-model="chooseExam" :label="scope.row.id">&nbsp;</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                    label=考试名称>
                        <template slot-scope="scope">
                            {{scope.row.examinationName}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                    fixed="right"
                                    width="60px"
                                    label=总分>
                        <template slot-scope="scope">
                            {{scope.row.totalScore}}
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrap">
                    <el-pagination background
                                style="margin-bottom:0"
                                @current-change="examPageChange"
                                :current-page.sync="pageEdu.pageNum"
                                :page-size="pageEdu.pageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="pageEdu.total">
                    </el-pagination>
                </div>
            </div>

            <span slot="footer"
                  class="dialog-footer">
                <el-button type="warning"
                            size="small"
                            :disabled="eduList.length<=0"
                            @click="sureChooseExam()">确 定</el-button>
                <el-button size="small"
                            type="info"
                            plain
                            @click="cancelChooseExam">取 消</el-button>
            </span>
        </el-dialog>

        <message-box :dialog-visible="dialogVisible"
                     :id="expertSeminarId"
                     :warning-text="warningText"
                     @handleConfirm="handleConfirm"
                     @handleClose="handleClose" />

        <el-dialog title="精品课程排序"
                   :visible.sync="sortVisible"
                   custom-class="group-dialog">
            <div class="table-dialog-wrap">
                <el-table :data="goodsList"
                          stripe
                          v-loading="goodsLoading"
                          style="width: 100%">
                    <el-table-column width="250px"
                                     label="课程">
                        <template slot-scope="scope">
                            <div class="image_title">
                                <el-image v-if="scope.row.pictureId"
                                          class="cover-picture"
                                          :src="'/ms-hoc-video/v1/image/download?fileName='+ scope.row.pictureId">
                                </el-image>
                                <div class="text_title">
                                    <span class="image_text">{{ scope.row.title }}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="doctorName"
                                     min-width="90px"
                                     label="来源医生">
                    </el-table-column>

                    <el-table-column fixed="right"
                                     label="排序"
                                     width="90">
                        <template slot-scope="scope">
                            <div
                                 class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="scope.row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="handleGoodsMoveUp(scope.row.expertSeminarId)"></i>

                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="scope.row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="handleGoodsMoveDown(scope.row.expertSeminarId)"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageBox from '@/components/MessageBox'
import shortcuts from '@/utils/pickerOptions'
import { postExpertSeminarList, deleteExpertSeminar, getExpertSeminarGrounding, getExpertSeminarDismounte, getMoveUp, getMoveDown, getGoodCourse, getCancleGoodCourse, getGoodsMoveUp, getGoodsMoveDown, getExamList, postRelation, postAddExam } from '@/api/expert'
import { postLabelList, postCheckLabel } from '@/api/labelManage'
export default {
    name: 'expertSeminar',
    data () {
        return {
            showWord: '课程共计 320 节；累计用户 179330人，累计学习 481221人次',
            onlineTime: '2020',
            examinationName: '',
            examLoading: false,
            relationId: '',
            chooseExam: '',
            isEduShow: false,
            eduLoading: false,
            eduList: [],
            eduData: {},
            examChooseList: [],
            pageEdu: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            isMoreShow: false,
            loading: false,
            dialogVisible: false,
            warningText: '',
            confirmType: '',
            expertSeminarId: '',
            datePickerOptions: {
                shortcuts: shortcuts
            },
            breadList: [
                { label: '内容管理' },
                { label: '医空间' }
            ],
            dataList: [],
            isStatsShow: true,
            selectForm: {
                title: '',
                addedTime: '',
                createTime: '',
                isUsed: '',
                doctorName: '',
                isGoods: '',
                seminarType: ''
            },
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            sortVisible: false,
            goodsList: [],
            goodsLoading: false,
            isModuleShow: false,
            moduleList: [],
            moduleData: {},
            moduleChooseList: [],

            moduleLoading: false,
            labelLoading: false,
            isLabelShow: false,
            labelList: [],
            labelData: {},
            labelChooseList: []
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    components: {
        MessageBox
    },
    filters: {
        formatDate (value) {
            if (value) {
                return value.substring(0, 16)
            } else {
                return ''
            }
        }
    },
    methods: {
        // 为了应付检查 之前写的
        // dataChange () {
        //     switch (this.onlineTime) {
        //     case '2020':
        //         this.showWord = '课程共计 320 节；累计用户 179330人，累计学习 481221人次'
        //         break
        //     case '2019':
        //         this.showWord = '课程共计 350 节；累计用户 182010人，累计学习 451260人次'
        //         break
        //     case '2018':
        //         this.showWord = '课程共计 300 节；累计用户 154632 人，累计学习 423924人次'
        //         break
        //     case '2017':
        //         this.showWord = '课程共计 230 节；累计用户 91632 人，累计学习 216823人次'
        //         break
        //     default:
        //         break
        //     }
        // },
        // 试卷管理 开始
        examPageChange (val) {
            this.pageEdu.pageNum = val
            this.getEduList()
        },
        // 考试名称搜索
        searchExam () {
            this.pageEdu.pageNum = 1
            this.getEduList()
        },
        async showEdu (data) {
            this.isEduShow = true
            this.eduLoading = true
            this.eduData = data
            let params = {
                current: 1,
                size: 1000,
                relationId: data.expertSeminarId
            }
            this.relationId = data.expertSeminarId
            this.getBandExam(params)
        },
        cancelChooseExam () {
            this.pageEdu.pageNum = 1
            this.examinationName = ''
            this.isEduShow = false
        },
        async getBandExam (params) {
            const { results } = await postRelation(params)
            this.chooseExam = results.records.length > 0 ? results.records[0].examId : ''
            this.getEduList()
        },
        async getEduList () {
            this.eduLoading = true
            let params = {
                status: 0,
                type: 0,
                examinationName: this.examinationName,
                pageSize: this.pageEdu.pageSize,
                pageNum: this.pageEdu.pageNum
            }
            const { list, total } = await getExamList(params)
            this.eduList = list || []
            this.pageEdu.total = total
            this.eduLoading = false
        },
        async sureChooseExam () {
            this.examLoading = true
            const param = {
                examIds: [this.chooseExam],
                relationId: this.relationId,
                relationType: '1'
            }
            const { results } = await postAddExam(param)
            if (results === 'ok') {
                this.$message.success('选择试卷成功')
            } else {
                this.$message.erning('选择试卷失败')
            }
            this.pageEdu.pageNum = 1
            this.examinationName = ''
            this.$refs.chooseEduTable.clearSelection()
            this.examLoading = false
            this.isEduShow = false
        },
        // 试卷管理 结束
        handleSelectionChange (value) {
            this.moduleChooseList = []
            value.forEach(item => {
                this.moduleChooseList.push({
                    moduleId: item.moduleId,
                    expertSeminarId: this.moduleData.expertSeminarId
                })
            })
        },
        async sureChooseModule () {
            if (this.moduleChooseList.length <= 0) {
                this.$message.warning('至少选择一个模块')
                return
            }
            this.moduleLoading = true
            const param = {
                expertModules: this.moduleChooseList
            }
            const { results } = await this.$services.moduleServices.addExpertModule(param)
            if (results) {
                this.$message.success('选择模块成功')
                this.isModuleShow = false
                this.queryExpertList()
            }
            this.moduleLoading = false
        },
        cancelChooseModule (type) {
            if (type === 'label') {
                this.isLabelShow = false
            } else {
                this.isModuleShow = false
            }
        },
        async showModule (data) {
            this.isModuleShow = true
            this.moduleData = data
            this.$nextTick(() => {
                // 默认选中
                this.moduleList.forEach(item => {
                    if (data.modules.findIndex(q => q.moduleId === item.moduleId) !== -1) {
                        this.$refs.chooseModuleTable.toggleRowSelection(item, true)
                    } else {
                        this.$refs.chooseModuleTable.toggleRowSelection(item, false)
                    }
                })
            })
        },
        async getModuleList () {
            const param = {
                current: 1,
                size: 1000000,
                hospitalId: this.userInfo.hospitalId
            }
            const { results } = await this.$services.moduleServices.getModuleList(param)
            this.moduleList = results
        },
        async showLabel (data) {
            this.isLabelShow = true
            this.labelData = data
            this.$nextTick(() => {
                // 默认选中
                this.labelList.forEach(item => {
                    if (data.labels.findIndex(q => q.labelId === item.labelId) !== -1) {
                        this.$refs.chooseLabelTable.toggleRowSelection(item, true)
                    } else {
                        this.$refs.chooseLabelTable.toggleRowSelection(item, false)
                    }
                })
            })
        },
        async sureChooseLabel () {
            // if (this.labelChooseList.length <= 0) {
            //     this.$message.warning('请勾选标签')
            //     return false
            // }
            this.labelLoading = true
            const param = {
                labels: this.labelChooseList,
                expertSeminarId: this.labelData.expertSeminarId
            }
            const { results } = await postCheckLabel(param)
            if (results) {
                this.$message.success('选择标签成功')
                this.isLabelShow = false
                this.queryExpertList()
            }
            this.labelLoading = false
        },
        async getLabelList () {
            const param = {
                current: 1,
                size: 1000000
            }
            const { results } = await postLabelList(param)
            this.labelList = results.records
        },
        handleLabelChange (val) {
            this.labelChooseList = []
            val.forEach(item => {
                this.labelChooseList.push(item.labelId)
            })
        },
        async handleMoveUp (expertSeminarId) {
            const { state } = await getMoveUp(expertSeminarId)
            if (state === 200) {
                this.query(this.page.current)
            }
        },
        async handleMoveDown (expertSeminarId) {
            const { state } = await getMoveDown(expertSeminarId)
            if (state === 200) {
                this.query(this.page.current)
            }
        },
        handleClose () {
            this.dialogVisible = false
        },
        handlePageChange (val) {
            this.query(val)
        },
        resetCondition () {
            this.selectForm.title = ''
            this.selectForm.doctorName = ''
            this.selectForm.isUsed = ''
            this.selectForm.addedTime = ''
            this.selectForm.createTime = ''
            this.selectForm.isGoods = ''
            this.selectForm.seminarType = ''
            this.query(1)
        },
        handleClick (expertSeminarId, type, isGoods) {
            this.expertSeminarId = expertSeminarId
            if (type === 'off') {
                if (isGoods) {
                    this.warningText = '该课程为精品课程，下线后将失效'
                    this.dialogVisible = true
                    this.confirmType = 'off'
                } else {
                    this.handleOff()
                }
            }
            if (type === 'on') {
                this.handleOn()
            }
            if (type === 'edit') {
                this.$router.push({ path: '/content/expertSeminar/edit', query: { expertSeminarId: expertSeminarId } })
            }
            if (type === 'delete') {
                this.warningText = '确认将此课程删除？'
                this.dialogVisible = true
                this.confirmType = 'delete'
            }
        },
        async setGoods (expertSeminarId, type) {
            const { state } = await getGoodCourse(expertSeminarId)
            if (state === 200) {
                this.$message({
                    message: '设置精品课程成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        async cancleGoods (expertSeminarId, type) {
            const { state } = await getCancleGoodCourse(expertSeminarId)
            if (state === 200) {
                this.$message({
                    message: '取消精品课程成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        async handleOff () {
            this.loading = true
            const { state } = await getExpertSeminarDismounte(this.expertSeminarId)
            if (state === 200) {
                this.$message({
                    message: '下线课程成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        async handleOn () {
            this.loading = true
            const { state } = await getExpertSeminarGrounding(this.expertSeminarId)
            if (state === 200) {
                this.$message({
                    message: '上线课程成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        handleConfirm () {
            this.dialogVisible = false
            if (this.confirmType === 'delete') {
                this.deleteNow()
            } else if (this.confirmType === 'off') {
                this.handleOff()
            }
        },
        async deleteNow () {
            this.loading = true
            const { state } = await deleteExpertSeminar(this.expertSeminarId)
            if (state === 200) {
                this.$message({
                    message: '删除课程成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        handleSearch () {
            this.query(1)
        },
        query (val) {
            this.page.current = val
            this.queryExpertList()
        },
        handleAdd () {
            this.$router.push('/content/expertSeminar/add')
        },
        queryShow () {
            const { title, addedTime, createTime, isUsed, doctorName, isGoods, seminarType } = this.selectForm
            let flag = title || isUsed || addedTime || createTime || doctorName || isGoods !== '' || seminarType
            this.isStatsShow = !flag
        },
        // 只拉取精品课程
        async queryGoodsList () {
            this.sortVisible = true
            this.goodsLoading = true
            let params = {
                isGoods: 1
            }
            const { results } = await postExpertSeminarList(params)
            this.goodsLoading = false
            if (results.length > 0) {
                this.$set(results[0], 'noMoveUp', true)
                this.$set(results[results.length - 1], 'noMoveDown', true)
            }
            this.goodsList = results
        },
        // 精品课程排序
        async handleGoodsMoveUp (expertSeminarId) {
            const { state } = await getGoodsMoveUp(expertSeminarId)
            if (state === 200) {
                this.queryGoodsList()
            }
        },
        async handleGoodsMoveDown (expertSeminarId) {
            const { state } = await getGoodsMoveDown(expertSeminarId)
            if (state === 200) {
                this.queryGoodsList()
            }
        },
        async queryExpertList () {
            let addedTimeStart = ''
            let addedTimeEnd = ''
            if (this.selectForm.addedTime) {
                addedTimeStart = this.selectForm.addedTime[0] + ' 00:00:00'
                addedTimeEnd = this.selectForm.addedTime[1] + ' 23:59:59'
            }
            let createTimeStart = ''
            let createTimeEnd = ''
            if (this.selectForm.createTime) {
                createTimeStart = this.selectForm.createTime[0] + ' 00:00:00'
                createTimeEnd = this.selectForm.createTime[1] + ' 23:59:59'
            }

            let params = {
                title: this.selectForm.title,
                isUsed: this.selectForm.isUsed,
                isGoods: this.selectForm.isGoods,
                uploader: this.selectForm.uploader,
                createTimeStart: createTimeStart,
                createTimeEnd: createTimeEnd,
                addedTimeStart: addedTimeStart,
                addedTimeEnd: addedTimeEnd,
                doctorName: this.selectForm.doctorName,
                size: this.page.pageSize,
                current: this.page.current,
                seminarType: this.selectForm.seminarType
                // hospitalId: '34' // 不加 查不出下架的课程
            }
            this.loading = true
            this.dataList = []
            const { results, total } = await postExpertSeminarList(params)
            if (results.length > 0) {
                for (let i = 0; i < results.length; i++) {
                    if (results[0].priorityLevel !== 0 && this.page.current === 1) {
                        this.$set(results[0], 'noMoveUp', true)
                    }
                    if (results[i].priorityLevel === 1) {
                        this.$set(results[i], 'noMoveDown', true)
                    }
                }
                this.dataList = results
                this.page.total = total
            } else {
                if (this.page.current > 1) {
                    this.page.current -= 1
                    this.queryExpertList()
                }
            }
            this.queryShow()
            this.loading = false
        },
        init () {
            this.queryExpertList()
            this.getModuleList()
            this.getLabelList()
        }
    },
    mounted () {
        this.init()
    }
}
</script>

<style lang="scss">
.pian-none {
    margin-top: 20px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
}
.choose-exma-dialog {
    .search-exam {
        margin-bottom: 20px;
        .search-doctor {
            width: 319px;
            vertical-align: middle;
            .el-input__inner {
                border-radius: 3px;
                border-color: #dcdcdc;
                padding: 8px 32px 8px 10px;
                height: 32px;
                font-size: 12px;
                &::-webkit-input-placeholder {
                    font-size: 12px;
                }
            }
            .el-input__suffix {
                background: $color-primary;
                color: #fff;
                right: 0;
                cursor: pointer;
                border-radius: 0 3px 3px 0;

                i {
                    display: inline-block;
                    width: 36px;
                    font-size: 14px;
                    line-height: 32px;
                    border-radius: 3px;
                }
            }
        }
    }
    .el-table .cell {
        display: block;
    }
    .el-dialog__footer {
        text-align: center;
    }
    .el-table__header-wrapper  .el-checkbox{//找到表头那一行，然后把里面的复选框隐藏掉
        display:none
    }
}
.short-popper {
    max-width: 300px;
    &.el-tooltip__popper.is-dark {
        background-color: #666666;
        border-radius: 4px;
        padding: 10px 12px;
        line-height: 16px;
    }

    &.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
        border-top-color: #666;
    }

    &.el-tooltip__popper[x-placement^="right"] .popper__arrow:after {
        border-right-color: #666;
    }
}
.choose-module-dialog {
    .el-table .cell {
        display: block;
    }
    .el-dialog__footer {
        text-align: center;
    }
}
.expert-seminar-wrap {
    .el-table .cell {
        display: block;
    }
    .expert-seminar-content {
        min-height: 600px;
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            font-size: 0;
            padding-bottom: 20px;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .search-wrap {
            display: flex;
            justify-content: space-between;
            .search-show-wrap {
                display: flex;
                .option-item {
                    display: inline-block;
                    font-size: 0;
                    margin: 0;
                    .label {
                        margin-left: 20px;
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                        display: inline-block;
                        width: 56px;
                        text-align: right;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-select {
                        margin-right: 10px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                    .el-input {
                        margin-right: 10px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                    .el-date-editor {
                        margin-right: 10px;
                    }
                }
            }
            .more-search {
                font-size: 0;
                color: #666;
                padding-left: 10px;
                cursor: pointer;
            }
            .more-search-text {
                font-size: 14px;
                line-height: 32px;
                padding-right: 3px;
            }
            .icon-drop_down {
                display: inline-block;
                font-size: 12px;
                color: #999;
                transition: transform 0.3s;
                transform: rotateZ(180deg);
                &.is-reverse {
                    transform: rotateZ(0deg);
                }
            }
        }

        .hide-wrap {
            margin-top: 8px;
            background: #f7f7f7;
            border: 1px solid #e6e6e6;
            padding-left: 20px;
            .option-wrap {
                display: flex;
                flex-wrap: wrap;
                &:last-child {
                    margin-bottom: 0;
                }
                .option-item {
                    display: inline-block;
                    font-size: 0;
                    margin: 20px 20px 20px 0;
                    .label {
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                        display: inline-block;
                        width: 56px;
                        text-align: right;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-select {
                        margin-right: 10px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                    .el-input {
                        margin-right: 10px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                    .el-date-editor {
                        margin-right: 10px;
                    }
                }
                .select-btn-wrap {
                    font-size: 0;
                    margin-top: 20px;
                    margin-bottom: 20px;
                    .el-button--small {
                        width: 80px;
                        padding: 8px 15px;
                        font-size: 14px;
                    }
                    .el-button--info.is-plain {
                        background: #f5f5f5;
                        border-color: #cccccc;
                        color: #666;
                    }
                }
            }
        }

        .table-wrap {
            margin-top: 20px;
            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
            .cover-picture {
                width: 70px;
                height: 70px;
                .image-slot {
                    .el-icon-picture-outline {
                        font-size: 70px;
                    }
                }
            }

            .image_title {
                display: flex;
                align-content: center;
                .cover-picture {
                    width: 70px;
                    height: 70px;
                }
                .text_title {
                    margin-left: 14px;
                    height: 70px;
                    width: 144px;
                    display: flex;
                    align-items: center;
                    .image_text {
                        font-family: PingFangSC-Regular;
                        font-size: 12px;
                        color: #333333;
                        line-height: 18px;
                        overflow: hidden;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                }
            }

            .status-warp {
                line-height: 12px;
                .el-badge {
                    height: 10px;
                    .el-badge__content {
                        width: 6px;
                        height: 6px;
                    }
                    .el-badge__content--success {
                        background: #4acfb1;
                    }
                    .el-badge__content--info {
                        background: #cccccc;
                    }
                }
                .status_text {
                    margin-left: 10px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    line-height: 12px;
                }
            }

            .status-on {
                .icon-off {
                    color: #ccc;
                }
                .icon-on {
                    cursor: pointer;
                    color: #3b8fd9;
                }
                .icon-paixuxia {
                    font-size: 16px;
                }
                .icon-paixushang {
                    font-size: 16px;
                    margin-right: 20px;
                }
            }
            .status-off {
                .icon-paixuxia {
                    font-size: 16px;
                    color: #ccc;
                }
                .icon-paixushang {
                    font-size: 16px;
                    color: #ccc;
                    margin-right: 20px;
                }
            }
            .star-status {
                .icon-off {
                    color: #ccc;
                    cursor: pointer;
                }
                .icon-on {
                    cursor: pointer;
                    color: #3b8fd9;
                }
            }
        }
    }
    .table-dialog-wrap {
            padding-bottom: 20px;
            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
            .cover-picture {
                width: 70px;
                height: 70px;
                .image-slot {
                    .el-icon-picture-outline {
                        font-size: 70px;
                    }
                }
            }

            .image_title {
                display: flex;
                align-content: center;
                .cover-picture {
                    width: 70px;
                    height: 70px;
                }
                .text_title {
                    margin-left: 14px;
                    height: 70px;
                    width: 144px;
                    display: flex;
                    align-items: center;
                    .image_text {
                        font-family: PingFangSC-Regular;
                        font-size: 12px;
                        color: #333333;
                        line-height: 18px;
                        overflow: hidden;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                }
            }

            .status-warp {
                line-height: 12px;
                .el-badge {
                    height: 10px;
                    .el-badge__content {
                        width: 6px;
                        height: 6px;
                    }
                    .el-badge__content--success {
                        background: #4acfb1;
                    }
                    .el-badge__content--info {
                        background: #cccccc;
                    }
                }
                .status_text {
                    margin-left: 10px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    line-height: 12px;
                }
            }

            .status-on {
                .icon-off {
                    color: #ccc;
                }
                .icon-on {
                    cursor: pointer;
                    color: #3b8fd9;
                }
                .icon-paixuxia {
                    font-size: 16px;
                }
                .icon-paixushang {
                    font-size: 16px;
                    margin-right: 20px;
                }
            }
            .status-off {
                .icon-paixuxia {
                    font-size: 16px;
                    color: #ccc;
                }
                .icon-paixushang {
                    font-size: 16px;
                    color: #ccc;
                    margin-right: 20px;
                }
            }
        }
}
</style>
